import CreateUserForm from "../components/form/CreateUserForm"
import { usePage } from "../contexts/PageProvider";
import { CREATE_USER_URL } from '../contexts/PageProvider';

// {extraFields, extraYupValidation, submitButtonChildren, children, submitUrl}
const USER_URL = "user";

const CreateUserPage = () => {
  const { pageData, setPageData } = usePage();
  if (pageData.url != CREATE_USER_URL) {
      setPageData({url: CREATE_USER_URL, title: "Fiche utilisateur"});      
  }

  return (
    <CreateUserForm 
        submitUrl={USER_URL}
        submitButtonChildren="Envoyer"
    />
  )
}

export default CreateUserPage